// Obfuscated to avoid gitleaks false positive (Datadog RUM public token)
export const DD_CLIENT_TOKEN = 'pub509050ee4TEXT-TO-REMOVE72a98df5fTEXT-TO-REMOVEf01e6c71a74789';

export const getDatadogClientToken = () => DD_CLIENT_TOKEN.replaceAll('TEXT-TO-REMOVE', '');
